export const API_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_PUBLIC_API_URL
    : process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:8080';
